type RouteType =
  | 'home'
  | 'login'
  | 'forgot_password'
  | 'reset_password'
  | 'accept_invite'
  | 'two_factor_setup'
  | 'two_factor_verify'
  | 'unauthorized'
  | 'error_404'
  | 'super_admin_dashboard'
  | 'super_admin_dashboard_organizations'
  | 'super_admin_dashboard_single_organization'
  | 'super_admin_dashboard_workspaces'
  | 'super_admin_dashboard_single_workspace'
  | 'super_admin_dashboard_projects'
  | 'super_admin_dashboard_single_project'
  | 'super_admin_dashboard_users'
  | 'super_admin_dashboard_single_user'
  | 'super_admin_dashboard_admins'
  | 'super_admin_dashboard_billing'
  | 'super_admin_dashboard_audit_log'
  | 'super_admin_dashboard_system_health'
  | 'super_admin_dashboard_account';

const Routes: Record<RouteType, { path: string }> = {
  home: {
    path: '/',
  },
  error_404: {
    path: '/404',
  },

  login: {
    path: '/login',
  },
  forgot_password: {
    path: '/forgot-password',
  },
  reset_password: {
    path: '/reset-password',
  },
  accept_invite: {
    path: '/accept-invite',
  },
  two_factor_setup: {
    path: '/2fa/setup',
  },
  two_factor_verify: {
    path: '/2fa/verify',
  },
  unauthorized: {
    path: '/unauthorized',
  },

  // -- SUPER ADMIN --
  super_admin_dashboard: {
    path: '/admin/dashboard',
  },
  super_admin_dashboard_organizations: {
    path: '/admin/dashboard/organizations',
  },
  // +id
  super_admin_dashboard_single_organization: {
    path: '/admin/dashboard/organizations',
  },
  super_admin_dashboard_workspaces: {
    path: '/admin/dashboard/workspaces',
  },
  // +id
  super_admin_dashboard_single_workspace: {
    path: '/admin/dashboard/workspaces',
  },
  super_admin_dashboard_projects: {
    path: '/admin/dashboard/projects',
  },
  // +id
  super_admin_dashboard_single_project: {
    path: '/admin/dashboard/projects',
  },
  super_admin_dashboard_users: {
    path: '/admin/dashboard/users',
  },
  // +id
  super_admin_dashboard_single_user: {
    path: '/admin/dashboard/users',
  },
  super_admin_dashboard_admins: {
    path: '/admin/dashboard/admins',
  },
  super_admin_dashboard_billing: {
    path: '/admin/dashboard/billing',
  },
  super_admin_dashboard_audit_log: {
    path: '/admin/dashboard/audit-log',
  },
  super_admin_dashboard_system_health: {
    path: '/admin/dashboard/system-health',
  },
  super_admin_dashboard_account: {
    path: '/admin/dashboard/account',
  },
};

export default Routes;
